import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';

export default function Index() {
  const { state, pathname } = useLocation();
  const { data } = state || {};

  const [currentTabItem, setCurrentTabItem] = useState(1);

  useEffect(() => {
    switch (pathname) {
      case routes.managers.plans.new.choose_template:
      case routes.managers.policy.index:
        setCurrentTabItem(1);
        break;
      case routes.managers.plans.new.company:
        setCurrentTabItem(2);
        break;
      case routes.managers.plans.new.plan_details:
        setCurrentTabItem(3);
        break;
      case routes.managers.plans.new.services:
        setCurrentTabItem(4);
        break;
      case routes.managers.plans.new.summary:
        setCurrentTabItem(5);
        break;
      case routes.managers.plans.new.success:
        setCurrentTabItem(0);
        break;
      default:
        setCurrentTabItem(1);
    }
  }, [pathname]);

  return (
    <>
      {currentTabItem > 0 && <StepTab total={data?.isFree ? 4 : 5} current={currentTabItem} />}

      <div className="content">
        <Outlet />
      </div>
    </>
  );
}
